class CardsExpand {
  constructor(element) {
    this.parent = element
    this.button = this.parent.querySelector(".cards__expand")
    this.list = this.parent.querySelector(".cards__list--hidden")
    if (this.button) {
      this.listen()
    }
  }

  listen() {
    this.button.addEventListener("click", () => {
      this.button.remove()
      this.list.style.maxHeight = this.list.scrollHeight + "px"
    })
  }
}

export default CardsExpand
